/**
 * Configuration file for everything frontend related
 * Copyright: © 2026 tecera gmbh
 * Author: AT
 * Date: 2024
 */

// Mirrors Django's `DEBUG = os.getenv("DEBUG", "TRUE") == "TRUE"`.
// NOTE: unlike Django (runtime), this is resolved at BUILD time — Rollup
// replaces `process.env.DEBUG` with the env value (from env/ewe_dev.env or the
// shell), so changing DEBUG requires a rebuild. Defaults to TRUE when unset.
export const DEBUG = process.env.DEBUG === "TRUE";
export const DOCKER = false;

// Definition of API Endpoints
export const BASE_API_URL = DOCKER ? "http://localhost/api" :(DEBUG ? "http://localhost:8000/api" : "https://water-monitoring.2kai.eu/api")

// Regex TODO: das hier
export const PASSWORD_REGEX = ".{8,}"; // Minimum 8 characters

export const ENABLE_LIVE_RELOADING = true;     // true
// Refresh intervall for devices in seconds -- NOT USED! TODO: Fix this triggering Device reactivity
export const DEVICE_REFRESH_INTERVALL_IN_SECONDS = 3600;    // Default: 3600

// Refresh intervall for alarms in seconds 
export const ALARM_REFRESH_INTERVALL_IN_SECONDS = 30;   // Default: 30

/**
 * Refresh intervall for data in seconds
 * Default: 30
 * @type {Number}
 */
export const DATA_REFRESH_INTERVALL_IN_SECONDS = 30;